// acessos-02 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "%{total} acessos ativos deste funcionário agora, contando este. \"Revogar todos\" encerra os %{total}.": "%{total} accesos activos de este empleado ahora, incluido este. \"Revocar todos\" finaliza los %{total}.",
    "%{total} ativos": "%{total} activos",
    "Acessos deste funcionário": "Accesos de este empleado",
    "Conectado desde": "Conectado desde",
    "Funcionários com mais de um acesso": "Empleados con más de un acceso",
    "só este": "solo este",
    "Último acesso": "Último acceso",
};

export default catalogo;
